// Development Submenu Component
let DevelopmentSubmenuComponent = {
    submenuComponent: {},
    submenuNav: {},
    subMenu: [],
    hasSubmenu: false,
    init: function(container) {

        this.submenuComponent = container;

        // Fix the menu position
        this.submenuComponent.style.top = document.querySelector('.header-component').offsetHeight + 'px';
        this.initDevelopmentMenu();

        windowUtils.addOrientationListener(this.initDevelopmentMenu());

        window.addEventListener("resize", () => {this.initDevelopmentMenu();}, {passive: true});

    },
    initDevelopmentMenu: function() {
        if (navUtils.isTabletOrMobile()) {
            this.initMobileDevelopmentMenu();
        } else {
            this.initDesktopDevelopmentMenu();
        }
    },
    initDesktopDevelopmentMenu: function() {

        const desktopDevSubmenu = this.submenuComponent.querySelector('.submenu-list');
    
        if (desktopDevSubmenu) {
            if (!desktopDevSubmenu.classList.contains('js-init')) {
        
                this.initDesktopSubmenu();
                this.initDesktopMainmenu();

                desktopDevSubmenu.classList.add('js-init');
            }
        }
    },
    initDesktopMainmenu: function() {
        let mainMenu = this.submenuComponent.querySelectorAll('.submenu-list > li > a[href^="#"]');
        mainMenu.forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
                this.setActiveDevelopmentMenuItem(anchor);
                this.hideSubmenu();
                e.preventDefault();
                navUtils.scrollToWithCorrection(e.target.getAttribute('href'), e.target);
            });
        });            
    },
    initDesktopSubmenu: function() {
        this.submenuNav = document.getElementById('submenuNav');
        this.subMenu = this.submenuComponent.querySelectorAll('.submenu-list .subnav a[href^="#"]');
        if (this.submenuNav) {
            if (this.subMenu.length) {
                this.hasSubmenu = true;
                this.subMenu.forEach((anchor) => {
                    anchor.addEventListener('click', (e) => {
                        this.setActiveDevelopmentSubmenuItem(anchor);
                        this.submenuNav.hidden = false;        
                        e.preventDefault();
                        navUtils.scrollToWithCorrection(e.target.getAttribute('href'), e.target);
                    });
                });

                //get the development menu dropdown
                const openSubmenuDropdown = document.querySelector('.open-submenu');
                // if there is one then set up the click handler
                if (openSubmenuDropdown) {
                    openSubmenuDropdown.addEventListener('click', (e) => {
                        this.setActiveDevelopmentMenuItem(e.target);
                        this.toggleSubmenu();
                        this.selectFirstSubmenuItem();
                    });

                    // the open-submenu link has no href, so is not tabbable, so use containing LI
                    let developmentDropdownLi = openSubmenuDropdown.parentElement;
                    developmentDropdownLi.setAttribute('tabindex', 0);
                    developmentDropdownLi.addEventListener('keyup', (e) => {
                        if (e.code === 'Enter') {
                            this.setActiveDevelopmentMenuItem(e.target.querySelector('a'));
                            this.toggleSubmenu();
                            this.selectFirstSubmenuItem();
                        }
                    });
                }
            } else {
                document.querySelector('#submenuNav').parentNode.remove();
            }
        }
    },
    toggleSubmenu: function() {
        if (this.submenuNav.hidden === true) {
            this.submenuNav.hidden = false;
        } else {
            this.submenuNav.hidden = true;
        }
    },
    hideSubmenu: function() {
        if (this.hasSubmenu) {
            this.submenuNav.hidden = true;
        }
    },
    selectFirstSubmenuItem: function() {
        let firstSubmenuItem = this.subMenu[0];
        this.setActiveDevelopmentSubmenuItem(firstSubmenuItem);
        navUtils.scrollTo(firstSubmenuItem.getAttribute('href'));
    },
    initMobileDevelopmentMenu: function() {
        const mobileDevSubmenu = this.submenuComponent.querySelector('.select-wrapper-list');
    
        if (!mobileDevSubmenu.classList.contains('js-init')) {
            const devDropdownMenu = document.querySelector('.select-wrapper-list #dropDown');
            if (devDropdownMenu) {
                devDropdownMenu.addEventListener('change', (e) => {
                    if (e.target.selectedIndex !== 0) {
                        let target = e.target.value;
                        window.location.href = target;
                        if (target.charAt(0) === '#') {
                            navUtils.scrollToWithCorrection(target, e.target.selectedOptions[0]);
                        }
                    }
                }, {passive: true});
            }
            mobileDevSubmenu.classList.add('js-init');
        }
    },
    setActiveDevelopmentMenuItem: function(anchor) {
        this.submenuComponent.querySelectorAll('.submenu-list > li.active').forEach( (item) => {
            item.classList.remove('active');
        });
        anchor.parentElement.classList.add('active');
    },    
    setActiveDevelopmentSubmenuItem: function(anchor) {
        this.submenuNav.querySelectorAll('a.active').forEach( (submenuAnchor) => {
            submenuAnchor.classList.remove('active');
        });
        anchor.classList.add('active');
    }
};

// Check for Submenu component when the document has loaded and initialise if we have one 
window.addEventListener('load', function () {
    const submenuComponent = document.querySelector('.submenu-component');
    if (submenuComponent) {
        DevelopmentSubmenuComponent.init(submenuComponent);
    }
});